module.exports = __webpack_public_path__ + "e9edbef9da3ab5094117fc3c247c1e07.jpg";